import React from 'react';
import Leasehold from 'src/models/leasehold/Leasehold';
import Dialog from 'src/components/common/Dialog';
import DialogList from 'src/dialogs';
import Button from 'src/components/controls/forms/redesign/FormButton';
import moment from 'moment';

export interface ILeaseholdPickerProps {
    navigate: (path: string) => void;
    getLeaseholds: (ownershipId: number) => void;
    hideDialog: () => void;
}

export type ILeaseholdPickerStateProps = {
    ownershipId: number;
    leaseholds: Array<Leasehold>;
};

type ILeaseholdPickerPageProps = ILeaseholdPickerProps & ILeaseholdPickerStateProps;

export class LeaseholdPicker extends React.Component<ILeaseholdPickerPageProps> {
    constructor(props: ILeaseholdPickerPageProps) {
        super(props);
    }

    onNavigate = (leaseholdId: string) => {
        this.props.navigate(`/ownership/${this.props.ownershipId}/leasehold/${leaseholdId}`);
        this.props.hideDialog();
    };

    leaseholdList = () => {
        if (this.props.leaseholds && this.props.leaseholds.length > 0) {
            return this.props.leaseholds.map((leasehold) => {
                return (
                    <div className="dialog-card-list" key={leasehold.id} onClick={() => this.onNavigate(leasehold.id.toString())}>
                        <div className="leasehold-picker-column-10">
                            <span>{leasehold.id}</span>
                        </div>

                        <div className="leasehold-picker-column-30">
                            {`${
                                leasehold.isActiveLease
                                    ? 'Active'
                                    : leasehold.isHistoricalLease
                                    ? 'Expired'
                                    : leasehold.isTopLease
                                    ? 'Top Lease'
                                    : 'HBP'
                            }`}
                        </div>

                        <div className="leasehold-picker-column-30">{`Vol: ${leasehold.book} / Pg: ${leasehold.page}`}</div>
                        <div className="leasehold-picker-column-30">{`${moment(leasehold.leaseDate).format('MM-DD-YYYY')}`}</div>
                    </div>
                );
            });
        } else {
            return <div>No Leaseholds for this Ownership</div>;
        }
    };

    render() {
        return (
            <Dialog dialogName={DialogList.LEASEHOLD_PICKER} title="Select a Leasehold Record">
                <div>
                    <div>
                        <div className="leasehold-picker-column-10 leasehold-picker-heading">ID</div>
                        <div className="leasehold-picker-column-30 leasehold-picker-heading">Status</div>
                        <div className="leasehold-picker-column-30 leasehold-picker-heading">Recording</div>
                        <div className="leasehold-picker-column-30 leasehold-picker-heading">Date</div>
                    </div>
                    {this.leaseholdList()}
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: '1rem' }}>
                    <Button text="CREATE NEW" intent="primary" onClick={() => this.onNavigate(`create-new`)} />
                    <Button text="COPY FROM EXISTING" intent="primary" disabled={true} />
                </div>
            </Dialog>
        );
    }
}

export default LeaseholdPicker;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/LeaseholdPicker.tsx